export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY?.trim();

if (!RECAPTCHA_SITE_KEY) {
    throw new Error("Configure REACT_APP_RECAPTCHA_SITE_KEY com a chave publica do reCAPTCHA v2.");
}
